function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "path",
  d: "M.28,1.455v9.552H2.827v3.264L3.862,13.4l3.025-2.388h6.129V.818H.28Zm11.463.637V9.733H6.409l-.159.159L4.1,11.564V9.733H1.554V2.092ZM14.29,4.639h2.547v7.642H14.29v1.831l-2.309-1.831H7.205L5.613,13.554H11.5l4.06,3.264V13.554h2.547V3.365H14.29Z",
  transform: "translate(-0.28 -0.818)",
  fillRule: "evenodd"
});

var SvgTalkSolid = function SvgTalkSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17.831,
    height: 16,
    viewBox: "0 0 17.831 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTalkSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/talk-solid.a8a7e857.svg";
export { ForwardRef as ReactComponent };